<template>
  <input
    :id="id"
    :name="id"
    type="checkbox"
    :disabled="disabled"
    :title="disabled ? disabledReason : ''"
    :checked="checked"
    :data-testid="id"
    :class="{
      'tw-h-4 tw-w-4 tw-rounded tw-border tw-border-solid tw-border-slate-300': true,
      'tw-cursor-pointer tw-text-deep-orange-500 focus:tw-ring-deep-orange-500': !disabled,
      'tw-cursor-not-allowed tw-text-slate-300': disabled
    }"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'StudioCheckbox',
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disabledReason: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: 'studio-checkbox'
    }
  }
});
</script>
